module.exports = __webpack_public_path__ + "img/drug_enforcement-stage_1.4.6888e7ab.jpg";